// extracted by mini-css-extract-plugin
export default {"wrap":"LoginPage_wrap__jRztL"};